<template>
    <v-container fluid>

        <v-row align="start" justify="center">
            <v-col cols="12" md="12" sm="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        Tag List
                        <div class="flex-grow-1"></div>
                        <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        ></v-text-field>
                        
                    </v-card-title>

                    <v-card-text>
                        <v-divider></v-divider>
                        <v-data-table
                            :headers="headers"
                            :items="tags"
                            :items-per-page="20"
                            :search="search"
                            class="elevation-1"
                            >
                            <!-- <template v-slot:item.image="{ item }">
                              <v-avatar @click="editItem(item)" class="eHover">
                                <img :src="item.image" :alt="item.name" />
                              </v-avatar>
                                
                            </template> -->
                            <template v-slot:item.action="{ item }">
                                <v-btn :href="'https://juzzap.com/0001/'+item.unique_tag" target="_blank" fab x-small dark class="mr-1" color="red">
                                              
                                    <v-icon class="white--text" small>mdi-web</v-icon>
                                              
                                </v-btn>
                                <!-- <v-btn @click="deleteItem(item)" color="red" fab x-small dark class="mr-0">
                                    <v-icon small >mdi-delete</v-icon>
                                </v-btn> -->
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
import Vue from 'vue'
export default {
    data: () => ({
        search: "",
        headers: [
        { text: "Tag", value: "unique_tag", sortable: false },
        { text: "Business", value: "business" },
        { text: "Agent", value: "agent" },
        { text: "Assign Date", value: "created_at" },
        { text: "Activation", value: "zaped" },
        { text: "Public", value: "public" },
        { text: "Ref. No", value: "refno" },
        { text: "Tag Location", value: "refno" },
        { text: "Remark", value: "remark"},
        { text: "Actions", value: "action", sortable: false }
        ],
        tags: []
    }),
    created() {
      
      this.$http
      .get(this.$apidomain+"agent/taglistall")
      .then(res => {
       this.tags = res.data.tag;
      })
      .catch(err => {
        console.log(err.response);
      });
  },

}
</script>